'use strict';

exports.__esModule = true;
exports.fetchAvailableServices = undefined;

var _fetch = require('./fetch');

// eslint-disable-next-line import/prefer-default-export
var fetchAvailableServices = exports.fetchAvailableServices = function fetchAvailableServices() {
    var url = (0, _fetch.getMarketUrl)() + '/api/appwise/v2/core/users/me/services/enabled?page_size=1000';
    return (0, _fetch.get)(url);
};